import type { ServiceBranch, ServiceStatus } from '@/lib/db/types';

export const SERVICE_BRANCHES: { id: ServiceBranch; abbr: string; label: string }[] = [
  { id: 'Army', abbr: 'ARMY', label: 'Army' },
  { id: 'Navy', abbr: 'USN', label: 'Navy' },
  { id: 'Marines', abbr: 'USMC', label: 'Marines' },
  { id: 'Air Force', abbr: 'USAF', label: 'Air Force' },
  { id: 'Coast Guard', abbr: 'USCG', label: 'Coast Guard' },
  { id: 'Space Force', abbr: 'USSF', label: 'Space Force' },
];

export const SERVICE_STATUSES: { id: ServiceStatus; label: string; abbr: string }[] = [
  { id: 'Active', label: 'Active Duty', abbr: 'Active' },
  { id: 'Reserve', label: 'Reserve', abbr: 'Reserve' },
  { id: 'Family', label: 'National Guard', abbr: 'Guard' },
  { id: 'Veteran', label: 'Veteran', abbr: 'Vet' },
  { id: 'Retired', label: 'Retired', abbr: 'Ret.' },
];

export function formatServiceTag(
  branch: ServiceBranch | null | undefined,
  rank: string | null | undefined,
  status: ServiceStatus | null | undefined,
): string | null {
  if (!branch) return null;
  const b = SERVICE_BRANCHES.find((x) => x.id === branch);
  if (!b) return null;
  const parts: string[] = [b.abbr];
  if (rank?.trim()) parts.push(rank.trim());
  if (status && status !== 'Active') {
    const s = SERVICE_STATUSES.find((x) => x.id === status);
    if (s) parts.push(s.abbr);
  }
  return parts.join(' · ');
}
